import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

interface RichContentProps {
  html: string;
  className?: string;
}

const RichContent: React.FC<RichContentProps> = ({ html, className = '' }) => {
  const sanitizedHtml = useMemo(() => {
    return DOMPurify.sanitize(html || '', {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: [
        'allow',
        'allowfullscreen',
        'frameborder',
        'scrolling',
        'target',
        'rel',
        'loading',
        'decoding',
        'referrerpolicy',
      ],
    });
  }, [html]);

  return (
    <div
      className={`prose prose-slate max-w-none prose-a:text-blue-700 prose-a:no-underline hover:prose-a:underline prose-img:rounded-2xl prose-img:shadow-sm prose-headings:tracking-tight [&_iframe]:aspect-video [&_iframe]:w-full [&_iframe]:rounded-2xl ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default RichContent;
